<script lang="ts">
    export let direction = "right";
    export let isPaused = false;
    export let rootElement;
    let flipsvg = false;

    if (direction == "left") {
      flipsvg = true;
    }
</script>

<style lang="scss">
  * {
    .shapes > * {
    opacity: 0;
    animation-duration: 7s;
    animation-iteration-count: infinite;
    animation-timing-function: steps(1);
  }
  .paused .shapes > * {
    filter: grayscale(100%);
      opacity: 0.8;
      animation-play-state: paused;
    }
  
  .flip .shapes > *{
    transform-origin: center center;
    transform: scaleX(-1); }

    @keyframes curtsy-lunge-1 {
    0%,
    12.5% {
      opacity: 1;
    }
    12.5%,
    50% {
      opacity: 0;
    }
    50%,
    62.5% {
      opacity: 1;
    }
    62.5%,
    100% {
      opacity: 0;
    }
  }
  #curtsy-lunge-1 {
    animation-name: curtsy-lunge-1;
  }
  @keyframes curtsy-lunge-2 {
    0%,
    12.5% {
      opacity: 0;
    }
    12.5%,
    25% {
      opacity: 1;
    }
    25%,
    37.5% {
      opacity: 0;
    }
    37.5%,
    50% {
      opacity: 1;
    }
    50%,
    100% {
      opacity: 0;
    }
  }
  #curtsy-lunge-2 {
    animation-name: curtsy-lunge-2;
  }
  @keyframes curtsy-lunge-3 {
    0%,
    25% {
      opacity: 0;
    }
    25%,
    37.5% {
      opacity: 1;
    }
    37.5%,
    100% {
      opacity: 0;
    }
  }
  #curtsy-lunge-3 {
    animation-name: curtsy-lunge-3;
  }
  @keyframes curtsy-lunge-4 {
    0%,
    62.5% {
      opacity: 0;
    }
    62.5%,
    75% {
      opacity: 1;
    }
    75%,
    87.5% {
      opacity: 0;
    }
    87.5%,
    100% {
      opacity: 1;
    }
  }
  #curtsy-lunge-4 {
    animation-name: curtsy-lunge-4;
  }
  @keyframes curtsy-lunge-5 {
    0%,
    75% {
      opacity: 0;
    }
    75%,
    87.5% {
      opacity: 1;
    }
    87.5%,
    100% {
      opacity: 0;
    }
  }
  #curtsy-lunge-5 {
    animation-name: curtsy-lunge-5;
  }

 
  }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 538.2 564.5" height="100%" width="100%">>
<g class:paused={isPaused} class:flip={flipsvg}>
  <g class="shapes" bind:this={rootElement}>
    <g id="curtsy-lunge-1">
      <path
        d="M202 157c-2 0-2-2-1-3 4-14 8-27 14-40 3-8 9-11 16-14l31-11 9 11c2 1 1 5 4 5a70 70 0 0 0 23 0c7-1 11-6 13-13l37 17c7 3 8 10 11 15l11 31c1 4 2 8-2 10-5-3-9 0-12 3-6 4-12 6-18 8l-4-5-1 22-2 47c-1 14 1 29 2 44 1 6-1 7-6 6a20 20 0 0 0-3 0l-24 1-68-5c-3 0-5-1-7 1a1 1 0 0 1-1 0c-1-3-2-6-1-10l7-52c2-17 0-33 1-49 0-6 2-12 1-18l-5 6c-8-5-17-4-25-7Z"
        fill="var(--shirt)"
      />
      <path
        fill="var(--pants)"
        d="M225 287c2-2 4-1 7-1l68 5 24-1 1 7c-2 12-4 24-3 37a207 207 0 0 0-2 30c0 3 0 5-4 5s-5 4-8 5c-11 0-21 0-31-6a4 4 0 0 0-4 0c-11 5-23 2-35 1-7-1-9-4-9-11-1-24-5-47-4-71Z"
      />
      <path
        fill="var(--flesh)"
        d="M238 369c12 1 24 4 35-1a4 4 0 0 1 4 0c10 6 20 6 31 6l-5 29a89 89 0 0 0 1 17c3 18-3 34-7 51-4 14-8 29-8 44a14 14 0 0 1-1 6c-5-4-10-4-16 1v-17c4-13 3-27 2-40-1-12-2-23 0-34 1-7 3-14 1-22a192 192 0 0 1-3-26c-2 15-6 30-4 45 2 10 3 20 1 29-3 18-4 35 0 52 1 3 1 7-3 9-5-2-10-1-14 2 1-24-8-46-12-69-2-12-3-24-1-36 3-15 1-31-1-46ZM338 176c6-2 12-4 18-8 3-3 7-6 12-3 2 14-1 29 2 43 5 23-2 45-4 67-1 14-4 27-1 41 2 12-6 24-18 27l-9 2c-5-2-4-5-1-8s7-6 8-12c0-2 3-4 0-5-4-2-5 1-7 3a77 77 0 0 1-4 8 3 3 0 0 1-3 1 2 2 0 0 1-1-3c3-8 2-17 9-23s11-14 10-25l-1-37c-1-16 0-32-6-47-2-7-1-14-4-21ZM202 157c8 3 18 2 25 7l-1 9c-1 12-8 23-7 35a112 112 0 0 1-8 46c-4 10-6 22-2 32s6 20 6 31c0 2 1 4-2 5-2 1-3-1-4-2s-2-4-4-2c-2 1-1 3 0 5l4 8c1 1 1 4-1 5s-4 0-5-1a11 11 0 0 0-6-4l-4-6-3-8c-4-9-3-17 0-25 4-12 4-23 2-35-2-19 1-39 4-58l1-7c3-11 4-23 5-35ZM311 92c-2 7-6 12-13 13a70 70 0 0 1-23 0c-3 0-2-4-4-5l-9-11c7-5 8-15 2-23l-4-12c-1-2-2-5 2-6l3 6c0-10 0-17 3-23 2-4 4-7 8-5a34 34 0 0 0 21 0c3-1 8-1 8 3 1 6 6 11 6 18 0 1-1 3 1 4 3 0 2-3 3-4 3 3 3 12-1 16s-5 9-7 14c-2 6-2 11 4 15Z"
      />
      <path
        fill="var(--hair)"
        d="M252 520c4-3 9-4 14-2 0 4 0 7 6 4 6-5 11-5 16-1 5 8 10 16 9 25-1 13-18 19-28 12-1-1-2-2-4-1-17 8-26 1-23-18 1-7 3-14 10-19ZM315 47c-1 1 0 4-3 4-2-1-1-3-1-4 0-7-5-12-6-18 0-4-5-4-8-3a34 34 0 0 1-21 0c-4-2-6 1-8 5-3 6-3 13-3 23l-3-6c-2-10 2-21-2-32-1-3 1-5 4-6 10-6 21-9 33-6 4 1 6 4 10 6 16 10 7 24 8 37Z"
      />
    </g>
    <g id="curtsy-lunge-2">
      <path
        fill="var(--hair)"
        d="M152 3c6 2 13 2 15 10 11 1 9 10 9 17l-2 9h-3a12 12 0 0 0-3-7 7 7 0 0 1-1-5c0-7-4-10-10-8a52 52 0 0 1-21 1c-6-1-7 1-8 7 0 4-1 9-7 11l1-23c0-5 3-8 8-9 4-1 8 0 12-3Z"
      />
      <path
        fill="var(--shirt)"
        d="M169 88c5 0 9 2 14 3l21 2c7 0 12 3 17 7a31 31 0 0 0 9 11c7 10 16 18 23 27l3 3c4 5 4 5-2 7a13 13 0 0 0-2 1c-11 2-21 6-29 15-3 1-5 1-6-3a18 18 0 0 0 0-4l-2-2-2 2c3 4-1 8-1 12-1 26 1 52-1 77 0 4 0 8-3 10a38 38 0 0 0-20 15c-1 1-2 3 0 4 9 1 2 3 0 5-5 1-9 0-12-4-7-11-17-14-29-15-5-1-10-2-14-6 5-1 9 2 13 3 2 0 4 2 5 0s1-5-2-6c-7-1-12-6-19-7-6 0-10-4-15-8-4-3-5-8-6-13l-11-38c-3-12-5-12-13-4l-6 6c-1 1-2 2-4 1-1-4 0-8-2-13-2-4-6-3-9-5-4-3-6-8-11-9v-4c9-7 15-16 21-25 7-10 18-15 29-21a49 49 0 0 0 12-9 13 13 0 0 1 9-4c0 6 7 11 13 12 10 1 18-2 26-5 6-2 6-9 9-14 3-2-4-1-3-4Z"
      />
      <path
        fill="var(--pants)"
        d="M147 261c12 1 22 4 29 15 3 4 8 5 13 4 0 5 2 6 5 2 1-1 2-3 4-3h4l-3 6c-1 2-3 3 0 5s3 0 4-2l3-1v4a123 123 0 0 1-11 34c-1 3-1 5 1 7 3 6 7 11 9 18-5 0-9 3-13 6-5 4-10 5-16 6l-15 4c-4 0-5 4-6 7-2 4-5 6-9 3-1-2-4-3-6-3-10-4-18-9-25-17 1-7 4-12 7-18 2-6 2-11-1-17-7-17-13-33-13-52 4 0 5 3 7 5a70 70 0 0 0 8 9c2 1 4 2 6 0s0-3-2-5a42 42 0 0 1-7-8c-1-1-2-2-1-3a3 3 0 0 1 3 0l4 3 12 7a3 3 0 0 0 5-1c1-2 0-3-1-4s-4-2-4-5l4 1c3 1 7 3 9 0 2-4-4-4-4-7Z"
      />
      <path
        fill="var(--flesh)"
        d="m161 366 15-4c6-1 11-2 16-6 4-3 8-6 13-6a35 35 0 0 1 7 18 20 20 0 0 0 4 11c5 7 5 16 4 25 0 5 0 11 4 15 10 12 11 27 14 41 2 11 2 21 7 31 2 5 4 11 8 15a12 12 0 0 1 4 7h-13c-4 0-5 2-4 6a16 16 0 0 0 1 5v4c-2 3-3-1-4 0-3-3-3-7-3-10-1-11-7-19-12-28l-29-52c-3-7-3-14-2-22 0-7-2-12-6-17-9-10-17-21-24-33ZM147 261c0 3 6 3 4 7-2 3-6 1-9 0l-4-1c0 3 2 4 4 5s2 3 1 4a3 3 0 0 1-5 1l-12-7-4-3a3 3 0 0 0-3 0c-1 1 0 2 1 3a42 42 0 0 0 7 8c2 2 4 3 2 5s-4 1-6 0a70 70 0 0 1-8-9c-2-2-3-5-6-5-11-4-18-15-29-20-16-7-30-18-43-30a45 45 0 0 1-7-9c-2-3-1-7 1-10l22-36a9 9 0 0 0 0-2c5 1 8 6 11 9 3 2 7 1 9 5 2 5 1 9 2 13-2 5-4 9-8 12-3 1-2 3-1 5 5 10 11 19 21 24 9 5 18 9 28 7 5 4 9 8 15 8 7 1 12 6 19 7 3 1 3 4 2 6s-3 0-5 0c-4-1-8-4-13-3 4 4 9 5 14 6ZM198 279c-2 0-3 2-4 3-3 4-5 3-5-2 1-2 8-4-1-6-2 0-1-2 0-3a38 38 0 0 1 20-15h7c7 0 10-4 12-10l2-10c3-14 10-27 9-42 0-3 0-6-2-8-6-7-9-15-13-22 8-9 18-13 29-15 4 6 5 14 7 21l2 8c5 9 5 18 2 27-4 16-9 31-15 46-2 5-5 9-9 14-7 9-19 13-26 24-2 2-4 2-7 2v-2c2-3 5-5 6-9a2 2 0 0 0 1-2 2 2 0 0 0 2-2h-1l-1 2a2 2 0 0 0-1 2c-4 1-5 4-6 7l-3 1c-1 2-2 4-4 2s-1-3 0-5l3-6c1-2 4-3 2-6-2 2-6 1-6 6ZM169 88c-1 3 5 2 4 5-3 4-4 11-10 13-8 3-16 6-26 5-6-1-12-6-13-12 4-1 6-5 6-9 1-10-3-19-7-27-3-4-5-9-1-14a4 4 0 0 0 0-4 8 8 0 0 1-1-7c6-2 7-7 7-11 1-6 2-8 8-7a52 52 0 0 0 21-1c6-2 10 1 10 8a7 7 0 0 0 1 5 12 12 0 0 1 4 7c-2 4 0 8-1 13l3-4c2 0 5 0 4 3-2 6-2 11-7 16a15 15 0 0 0-2 21ZM115 356c7 8 15 13 25 17l6 3c-1 5-5 8-8 11a96 96 0 0 0-20 33c-4 9-9 17-15 24-12 15-27 27-36 45l-4 4a7 7 0 0 0-5-4c-3-2-7-2-7-7a13 13 0 0 1 3-5c10-10 15-22 19-35 4-11 8-21 16-30 8-10 12-22 16-34l8-21a2 2 0 0 1 2-1Z"
      />
      <path
        fill="var(--hair)"
        d="M237 528c1-1 2 3 4 0v-4a16 16 0 0 1-1-5c-1-4 0-6 4-6h13l13 26a12 12 0 0 0 7 6c5 2 6 5 6 10s-5 5-9 5c-12 1-25 0-36-6-5-3-7-6-5-11l4-15ZM51 482c0 5 4 5 7 7a7 7 0 0 1 5 4 243 243 0 0 0-6 24 5 5 0 0 1-3 3c-7 3-14 4-21 2-5-1-7-4-6-9 0-4 1-7 4-9 6-5 11-10 15-17 1-2 2-5 5-5Z"
      />
      <path fill="var(--pants)" d="m174 48-3 4V39h3v9Z" />
      <path fill="var(--shirt)" d="M198 279c0-5 4-4 6-6 2 3-1 4-2 6Z" />
    </g>
    <g id="curtsy-lunge-3">
      <path
        fill="var(--flesh)"
        d="m118 296-14 17c-5 5-11 8-16 11-4 2-8 2-12-1-8-8-10-23-3-33 5-9 12-17 17-27l10 1c6 3 10 2 14-2 7-7 13-15 22-20 7-4 9-10 7-15l-3-7c1-5 2-9 8-10 4-1 6-9 5-13-1-6-4-11-6-16-2-3-3-6 2-7 2 0 0 3 2 3 1-3-1-7 1-10 4-3 4-6 4-10-1-6 1-8 7-7 8 1 16 2 24-1h4a8 8 0 0 1 9 6c2 8 6 16 4 24 2-2 2-6 2-9 3 0 5 1 5 5-1 6-2 11-7 14l-2 3c1 6-3 11-4 17-1 2 1 3 2 4a9 9 0 0 1 2 6c1 6-2 10-7 13l-8 6c1 4 5 7 9 10 7 5 16 7 24 12 6 4 13 8 20 6 7-3 14-2 21-3l1-1 10 22c1 2 1 3 3 3v14c-3 5-6 11-11 15-2 2-5 3-8 2a59 59 0 0 1-18-8l-18-13a8 8 0 0 0-1-2c-17-17-34-33-53-48-2-1-3-2-5 0-10 5-15 15-21 23l-22 26Z"
      />
      <path
        fill="var(--hair)"
        d="M249 518c6 11 8 24 18 33 6 5 4 10-4 13h-11l-12-3c-9-3-16-7-18-17v-5c3-6 3-11 2-17 2 0 2 3 3 4 1 2 3 3 5 3 3-1 1-3 1-5s1-5 3-4c4 0 8-3 13-2Z"
      />
      <path
        fill="var(--shirt)"
        d="M220 297c-6 21-13 42-14 64v14c0 3-1 7-6 7l-1-1-40-17c-11-5-22-9-35-4l-22 5c-2 0-4 0-5 2-3-4-1-7 0-10 8-14 13-29 19-45 2-5 2-10 2-16l21-26c7-8 12-18 22-23 2-2 3-1 5 0 18 15 36 31 53 48a8 8 0 0 1 1 2Z"
      />
      <path
        fill="var(--pants)"
        d="M97 367c1-2 3-2 5-2l22-5c13-5 24-1 35 4l40 17 1 1-1 3c-3-1-7-3-11-2-14 5-23 14-29 27-3 6 1 13 7 15 6 1 12 1 17 5-5 10-9 20-6 32 2 4 2 9 3 13 0 3 1 5-2 7s-6 2-8 1a38 38 0 0 1-5-3l-1-2c0-3 4-6 2-8-3-3-6-4-9-5a29 29 0 0 0-3-1h-3c-2 4-5 3-7 2-9 0-17 2-25 4-2-15 1-30 3-46 1-4 0-6-4-8a51 51 0 0 1-21-49Z"
      />
      <path
        fill="var(--flesh)"
        d="M183 430c-5-4-11-4-17-5-6-2-10-9-7-15 6-13 15-22 29-27 4-1 7 1 11 2 6 4 12 6 18 11 10 6 13 15 13 26v14a7 7 0 0 0 0 5c6 12 5 26 5 39 1 11 2 22 11 31l3 7c-5-1-9 2-13 1-2 0-3 3-3 5s2 4-1 5c-2 0-4-1-5-3-1-1-1-4-3-4a20 20 0 0 0-2-10c-6-11-11-23-18-34l-1-1a18 18 0 0 0-1-3c-6-12-10-24-5-38l-2-2c-2-4-6-4-9-4a2 2 0 0 0-1 0h-1ZM119 470c8-2 16-4 25-4 2 1 5 2 7-2h3a29 29 0 0 1 3 1c3 1 6 2 9 5 2 2-2 5-2 8l1 2c-6 7-9 16-15 23l-7 15c-3 9-10 14-19 13-6-1-13-2-18-7-3-3-8-4-12-6l-34-17a57 57 0 0 0-19-6c-2-4-3-8-9-6-1 1-1-1-2-2-3-6 0-12 7-12a13 13 0 0 0 7-1c15 4 30 6 45 7a41 41 0 0 1 20 7c3 2 4 1 5-2l5-16Z"
      />
      <path
        fill="var(--shirt)"
        d="m262 262-1 1c-7 1-14 0-21 3-7 2-14-3-20-6-8-5-17-7-24-12-4-3-8-6-9-10l8-6c5-3 8-7 7-13a9 9 0 0 0-2-6c-1-1-3-2-2-4 5 1 9 6 15 7 4 4 9 5 13 6 0 2 1 3 3 3 7-1 12 3 17 5 8 5 11 12 12 21 0 4 3 7 4 11Z"
      />
      <path
        fill="var(--hair)"
        d="M206 170c0 3 0 7-2 9 2-8-2-16-4-24a8 8 0 0 0-9-6h-4c-8 3-16 2-24 1-6-1-8 1-7 7 0 4 0 7-4 10-2 3 0 7-1 10-2 0 0-3-2-3-2-12-1-24 0-36a12 12 0 0 1 5-9c12-9 26-11 39-4 9 5 19 11 16 26-1 6-4 13-3 19ZM44 474a13 13 0 0 1-7 1c-7 0-10 6-7 12 1 1 1 3 2 2 6-2 7 2 9 6-7 1-9 8-13 13-2 2 0 3 0 4 3 8 1 11-7 13a46 46 0 0 1-8 2c-5 0-9-1-11-6s-3-9 0-14a26 26 0 0 1 2-3c6-6 10-13 10-22a30 30 0 0 1 3-13c2-5 6-6 11-4a113 113 0 0 0 11 4c2 1 5 2 5 5Z"
      />
      <path
        fill="var(--shirt)"
        d="m140 220 3 7c2 5 0 11-7 15-9 5-15 13-22 20-4 4-8 5-14 2l-10-1c1-14 10-24 21-31 9-6 20-7 29-12Z"
      />
    </g>
    <g id="curtsy-lunge-4">
      <path
        fill="var(--hair)"
        d="M385 0c-6 2-13 2-15 10-11 1-8 10-9 17l2 9h3a12 12 0 0 1 3-7 7 7 0 0 0 2-5c0-7 3-9 9-8a52 52 0 0 0 21 1c6-1 7 1 8 7 0 4 2 9 7 11l-1-23c0-5-3-8-7-9-5-1-9 0-13-3Z"
      />
      <path
        fill="var(--shirt)"
        d="M368 85c-5 0-9 2-13 3l-22 2c-7 0-12 3-17 7a31 31 0 0 1-9 11c-6 10-15 18-23 27l-3 3c-4 5-3 5 2 7a14 14 0 0 1 2 1c11 2 21 6 29 15 4 1 6 1 6-3a18 18 0 0 1 1-4l2-2 1 2c-3 4 1 8 1 12l1 77c1 4 1 8 4 10a38 38 0 0 1 20 15c1 1 1 3-1 4-8 1-1 3 0 5 5 1 9 0 12-4 7-11 18-14 30-15 4-1 9-2 14-6-6-1-10 2-14 3-2 0-3 2-5 0-1-2 0-5 3-6 6-1 11-6 18-7 6 0 11-4 15-8 4-3 5-8 7-13l10-38c3-12 5-12 13-4l6 6c1 1 2 2 4 1 1-4 0-8 2-13 3-4 7-3 9-5 4-3 6-8 11-9 2-1 2-2 0-4-8-7-15-16-21-25-7-10-18-15-29-21a49 49 0 0 1-12-9 12 12 0 0 0-9-4c0 6-7 11-13 12-9 1-17-2-26-5-6-2-6-9-9-13-2-3 4-2 3-5Z"
      />
      <path
        fill="var(--pants)"
        d="M391 258c-12 1-23 4-30 15-3 4-7 5-12 4-1 5-3 6-6 2-1-1-2-3-4-3h-4l3 6c1 2 3 4 1 5s-4 0-5-2l-3-1v4a123 123 0 0 0 11 34v7c-4 6-8 11-10 18 5 0 9 3 13 6 5 4 11 5 17 6l14 4c4 0 5 4 7 7 2 4 4 6 9 3 1-2 3-3 5-3 10-4 19-9 25-17 0-7-4-12-6-17-3-7-3-12 0-18 8-17 14-33 13-52-4 0-5 3-7 5a70 70 0 0 1-8 9c-2 1-4 2-6 0-1-2 1-3 2-5a42 42 0 0 0 8-8v-3a3 3 0 0 0-3 0l-4 3-12 7a3 3 0 0 1-4-1c-2-1-1-3 1-4s3-2 3-5l-4 1c-3 1-7 3-9 0-2-4 4-4 5-7Z"
      />
      <path
        fill="var(--flesh)"
        d="m376 363-14-4c-6-1-12-2-17-6-4-3-8-6-13-6a35 35 0 0 0-7 18 20 20 0 0 1-4 11c-5 8-5 16-4 25 0 5 0 11-3 15-10 12-12 27-14 41-2 11-3 21-7 31-3 5-5 11-9 15a12 12 0 0 0-3 7h12c5 0 5 2 5 6a16 16 0 0 1-2 5v4c2 3 3-1 5 0 3-3 2-7 2-10 1-11 8-19 12-27l29-53c4-7 3-14 3-22-1-6 1-11 6-17 8-10 17-21 23-33ZM391 258c-1 3-7 3-5 7 2 3 6 1 9 0l4-1c0 3-2 4-3 5s-3 3-1 4a3 3 0 0 0 4 1l12-7 4-3a3 3 0 0 1 3 0v3a42 42 0 0 1-8 8c-1 2-3 3-2 5 2 2 4 1 6 0a70 70 0 0 0 8-9c2-2 3-5 7-5 11-4 17-15 28-19 16-8 30-18 43-30a46 46 0 0 0 7-10c3-3 1-7-1-10l-22-36a9 9 0 0 1 0-2c-5 1-7 6-11 9-2 2-7 2-9 5-2 5-1 9-2 13 2 5 4 9 9 12 2 1 2 3 0 5-5 10-11 19-21 24-8 5-17 9-28 7-4 4-9 8-15 8-7 1-12 6-18 7-3 1-4 4-3 6s3 0 5 0c4-1 8-4 14-3-5 4-10 5-14 6ZM339 276c2 0 3 2 4 3 3 4 5 3 6-2-2-2-8-4 0-6 2 0 1-2 1-3a38 38 0 0 0-20-15h-8c-7 0-10-4-12-10l-2-10c-3-14-9-27-9-42 1-3 1-6 3-8 6-7 8-15 12-22-8-9-18-13-29-15-4 7-5 14-7 22l-2 7c-5 9-4 18-2 27 5 16 9 31 15 46 2 5 6 9 9 14 7 9 20 14 27 24 1 2 3 2 6 2v-2c-1-3-5-5-6-9a2 2 0 0 1-1-2 2 2 0 0 1-2-2h1l1 2a2 2 0 0 1 1 2c4 1 6 4 6 7l3 1c1 2 3 4 5 2s0-3-1-5l-3-6c-1-2-4-3-2-6 2 2 6 1 6 6ZM368 85c1 3-5 2-3 5 3 4 3 11 9 13 8 3 17 6 26 5 6-1 13-6 13-12-4-1-5-5-6-9-1-10 3-19 8-27 2-4 4-9 1-14a4 4 0 0 1 0-4 8 8 0 0 0 0-7c-5-2-7-7-7-11-1-6-2-8-8-7a52 52 0 0 1-21-1c-6-1-9 1-9 8a7 7 0 0 1-2 5 12 12 0 0 0-3 7v13c-2-1-2-3-2-4-3 0-5 0-4 3 1 6 1 11 6 16a15 15 0 0 1 2 21ZM422 353c-6 8-15 13-25 17-2 0-4 1-5 3 1 5 4 8 7 11 10 9 16 21 21 33 3 9 8 17 15 24 12 15 27 27 35 45l5 4a7 7 0 0 1 4-4c3-2 7-2 7-7a13 13 0 0 0-3-5c-9-10-15-22-19-35-3-11-8-21-15-30-9-10-13-22-17-34l-8-21a2 2 0 0 0-2-1Z"
      />
      <path
        fill="var(--hair)"
        d="M301 525c-2-1-3 3-5 0v-4a16 16 0 0 0 2-5c0-4 0-6-5-6h-12l-14 26a12 12 0 0 1-7 6c-4 2-6 6-5 10s4 5 8 5c12 1 25 0 36-6 5-3 7-6 6-11-2-5-4-10-4-15ZM486 479c0 5-4 5-7 7a7 7 0 0 0-4 4 240 240 0 0 1 5 24 5 5 0 0 0 3 3c7 3 14 4 22 2 5-1 7-4 6-9-1-4-2-7-5-9-6-5-11-10-14-17-1-2-3-5-6-5Z"
      />
      <path fill="var(--pants)" d="M364 45c0 1 0 3 2 4V36h-3l1 9Z" />
      <path fill="var(--shirt)" d="M339 276c0-5-4-4-6-6-2 3 2 4 2 6Z" />
    </g>
    <g id="curtsy-lunge-5">
      <path
        fill="var(--flesh)"
        d="m420 293 15 17c4 5 10 8 16 11 3 2 7 2 11-1 8-8 10-23 3-33-5-9-12-17-17-27l-10 1c-6 3-10 2-14-2-7-7-13-15-22-20-7-4-9-10-6-15l2-7c-1-5-2-9-8-10-4-1-6-9-5-13 1-6 4-11 7-16 1-3 2-6-3-7-1 0 0 3-2 3-1-3 2-7-1-10s-4-6-3-10c0-6-2-8-8-7-8 1-16 2-23-1h-5a8 8 0 0 0-8 6c-2 8-7 16-5 24-2-2-2-6-2-9-3 0-5 1-4 5 0 6 1 11 6 14l2 3c0 6 3 11 4 17 1 2 0 3-1 4a9 9 0 0 0-3 6c0 6 2 10 8 13l7 6c-1 4-4 7-8 10-8 5-17 7-25 12-6 4-13 8-20 6-7-3-14-2-21-3l-1-1-10 22-2 3v14c2 5 5 11 10 15 2 2 5 3 8 3a59 59 0 0 0 18-9l19-13a8 8 0 0 1 1-2c16-17 34-33 52-48 2-1 3-2 5 0 10 5 15 15 22 23l21 26Z"
      />
      <path
        fill="var(--hair)"
        d="M290 516c-6 10-9 23-19 32-6 5-4 10 4 13h11c4-2 8-2 13-3 9-3 15-7 17-17v-5c-3-6-3-11-2-17l-3 4c-1 2-2 3-5 3-2-1-1-3-1-5s0-5-2-4c-5 0-9-3-13-1Z"
      />
      <path
        fill="var(--shirt)"
        d="M319 294c5 21 12 42 13 64v14c1 3 1 7 7 7l1-1 39-17c11-5 23-9 35-4l23 5c1 0 3 0 5 2 2-4 1-7-1-10-8-14-13-29-19-44l-2-17-21-26c-7-8-12-18-22-23-2-2-3-1-5 0-18 15-36 31-52 48a8 8 0 0 0-1 2Z"
      />
      <path
        fill="var(--pants)"
        d="M442 364c-2-2-4-2-5-2l-23-5c-12-5-24-1-35 4l-40 17-1 1 1 3c4-1 7-3 11-2 14 5 24 14 30 27 3 6-1 13-8 15-5 2-12 1-17 5 6 10 9 20 6 32l-2 13c-1 3-1 5 1 7s6 2 9 1a37 37 0 0 0 5-3v-2c0-3-4-6-1-8 2-3 5-4 8-5a27 27 0 0 1 4-1h3c1 4 4 3 6 3 9-1 17 1 26 3 1-15-2-30-4-46 0-4 1-5 4-8 17-12 24-29 22-49Z"
      />
      <path
        fill="var(--flesh)"
        d="M355 427c6-4 12-3 17-5 7-2 11-9 8-15-6-13-16-22-30-27-4-1-7 1-11 2-5 4-12 6-18 11-9 6-13 15-13 26v14a7 7 0 0 1 0 5c-5 12-5 26-5 39 0 11-2 22-10 31-2 2-3 5-3 8 4-1 8 1 13 1 2-1 2 2 2 4s-1 4 1 5c3 0 4-1 5-3 1-1 1-4 3-4a20 20 0 0 1 2-10l19-34 1-1a18 18 0 0 1 0-3c6-12 11-24 6-37-1-2 0-3 1-3 2-3 6-4 9-4a2 2 0 0 1 1 0h1ZM420 467c-9-2-17-4-26-4-2 1-5 2-6-2h-3a27 27 0 0 0-4 1c-3 1-6 2-8 5-3 2 1 5 1 8v2c6 7 9 16 14 23l7 15c3 9 11 14 19 13 7-1 13-2 18-7 3-3 8-4 12-6l34-17a57 57 0 0 1 19-6c2-4 4-8 9-6 1 1 2-1 2-2 4-6 0-12-7-12a13 13 0 0 1-7-1c-15 4-30 6-45 7a41 41 0 0 0-19 7c-3 2-5 1-6-2-2-6-4-10-4-16Z"
      />
      <path
        fill="var(--shirt)"
        d="m276 259 1 1c7 1 14 0 21 3 7 2 14-3 20-6 8-5 17-7 25-12 4-3 7-6 8-10l-7-6c-6-3-8-7-8-13a9 9 0 0 1 2-6c1-1 3-2 2-4-5 1-9 6-15 7-3 4-8 5-13 6 0 2-1 3-3 3-7-1-12 3-17 5-8 5-11 12-12 21 0 4-3 7-4 11Z"
      />
      <path
        fill="var(--hair)"
        d="M332 167c0 3 0 7 2 9-2-8 3-16 5-24a8 8 0 0 1 8-6h5c7 3 15 2 23 1 6-1 8 1 8 7-1 4 0 7 3 10s0 7 2 10l1-3c2-12 1-24 0-35a12 12 0 0 0-5-10c-12-9-26-11-39-4-8 5-19 11-16 26 1 6 4 13 3 19ZM494 471a13 13 0 0 0 7 1c7 0 10 6 7 12 0 1-1 3-2 2-6-2-7 2-9 6 8 1 10 8 14 13 1 2 0 3-1 4-3 8-1 11 7 13a45 45 0 0 0 8 2c5 0 9-1 11-6s4-9 0-14a26 26 0 0 0-2-3c-6-6-9-13-9-22a30 30 0 0 0-4-13c-2-5-6-6-11-4a116 116 0 0 1-11 4c-2 1-4 2-5 5Z"
      />
      <path
        fill="var(--shirt)"
        d="m398 217-2 7c-3 5-1 11 6 15 9 5 15 13 22 20 4 4 8 5 14 2l10-1c-1-14-9-24-21-31-9-6-20-7-29-12Z"
      />
    </g>
  </g>
</g>
    {#if isPaused}
    <svg viewBox="-6 -5 36 36" width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 24h-6v-24h6v24zm10 0h-6v-24h6v24zm-11-23h-4v22h4v-22zm10 0h-4v22h4v-22z"/></svg>
    {/if} 
  </svg>